import React from "react";

// A boolean filter toggle rendered as a pill ("chip"). Used by both shop-search pages
// (car request + shop explorer) so their filters stay visually and behaviourally identical.
// Tap-to-toggle matches the shop cards' selection interaction; aria-pressed gives the same
// toggle-button semantics.
export default function FilterChip({ active = false, disabled = false, onToggle, children }) {
  return (
    <button
      type="button"
      aria-pressed={active}
      disabled={disabled}
      onClick={onToggle}
      className={
        "inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-medium transition " +
        "disabled:opacity-50 disabled:cursor-not-allowed " +
        (active
          ? "border-blue-600 bg-blue-600 text-white dark:border-blue-500 dark:bg-blue-500"
          : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700")
      }
    >
      {active ? <i className="not-italic fi fi-rr-check text-xs" aria-hidden="true" /> : null}
      {children}
    </button>
  );
}
